import { PROJECT_CATCH_ERROR_LIST } from "@platformx/utilities";
import graphqlInstance from "../../config/graphqlConfig";
import { SlugQueries } from "../../graphQL/queries/slugQueries";

/**
 * Slug-uniqueness validation service
 *
 */

export interface SlugValidationRequest {
  /** Item name / title typed by the editor (create flow). Sent as-is. */
  title?: string;
  /** Explicit slug value (e.g. a Page URL). Sent as-is. */
  slug?: string;
  /** Document type the uniqueness is scoped to, e.g. "Article" | "Vod". */
  docType: string;
  /**
   * Optional schema document type (only meaningful for schema-based/dynamic
   * content). Passed from CreateNewContent only — CreateNewPage never sends it.
   */
  schema_document_type?: string;
}

export interface SlugValidationResponse {
  /** Whether the slug is unique within the given docType. */
  isUnique: boolean;
  /** Optional server-provided message (e.g. collision detail). */
  message?: string;
}

const slugApi = {
  validateSlug: async (
    request: SlugValidationRequest,
    options?: { signal?: AbortSignal },
  ): Promise<SlugValidationResponse> => {
    const value = (request.slug ?? request.title ?? "").trim();

    try {
      const { data } = await graphqlInstance.query({
        query: SlugQueries.CHECK_SLUG_UNIQUENESS,
        variables: {
          slug: value,
          contentType: request.docType,
          schema_document_type: request.schema_document_type,
        },
        fetchPolicy: "no-cache",
        context: { fetchOptions: { signal: options?.signal } },
      });
      const result = data?.authoring_checkSlugUniqueness;
      return {
        isUnique: Boolean(result?.isUnique),
        message: result?.message,
      };
    } catch (err: any) {
      console.error(`${PROJECT_CATCH_ERROR_LIST.authoring}:validateSlug`, err);
      throw err;
    }
  },
};

export default slugApi;
